import React from "react";
import { getIcon } from "../../../../utils/images";
import "./NotificationEmpty.scss";

const NotificationEmpty = () => {

  return (
    <div className="NotificationEmpty">
      <img src={getIcon("no-notification")} />
      <div className="alert">
        You don't have notifications yet
      </div>
    </div>
  )

}

export default NotificationEmpty;